import React from 'react';

import { Icon } from '@chakra-ui/react';

export const ServerlessIcon = props => (
  <Icon viewBox="0 0 24 24" w="full" h="full" color="inherit" {...props}>
    <path
      stroke="currentColor"
      strokeWidth={0.5}
      strokeLinejoin="round"
      strokeLinecap="round"
      d="M6,9V5.5C6,4.1,7.1,3,8.5,3C8.8,3,9,2.8,9,2.5S8.8,2,8.5,2C6.6,2,5,3.6,5,5.5V9c0,1.4-1.1,2.5-2.5,2.5C2.2,11.5,2,11.7,2,12s0.2,0.5,0.5,0.5C3.9,12.5,5,13.6,5,15v3.5C5,20.4,6.6,22,8.5,22C8.8,22,9,21.8,9,21.5S8.8,21,8.5,21C7.1,21,6,19.9,6,18.5V15c0-1.3-0.7-2.4-1.7-3C5.3,11.4,6,10.3,6,9z M21.5,11.5c-1.4,0-2.5-1.1-2.5-2.5V5.5C19,3.6,17.4,2,15.5,2C15.2,2,15,2.2,15,2.5S15.2,3,15.5,3C16.9,3,18,4.1,18,5.5V9c0,1.3,0.7,2.4,1.7,3c-1,0.6-1.7,1.7-1.7,3v3.5c0,1.4-1.1,2.5-2.5,2.5c-0.3,0-0.5,0.2-0.5,0.5s0.2,0.5,0.5,0.5c1.9,0,3.5-1.6,3.5-3.5V15c0-1.4,1.1-2.5,2.5-2.5c0.3,0,0.5-0.2,0.5-0.5S21.8,11.5,21.5,11.5z"
    />
  </Icon>
);
